import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PARAMETERS_INIT_FAIL, STATISTICS_INIT_LOADING, STATISTICS_INIT_SUCCESS, STATISTICS_INIT_FAIL } from '@/store/types'
export const statistics = {
  async statisticsInit({ commit, state }) {
    const apiUrl = state.menu.statistics
    if (apiUrl) {
      commit(STATISTICS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(STATISTICS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(STATISTICS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PARAMETERS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  }
}
